/**
 * @file     formCopy.ts
 * @purpose  MessageRef catalog for form strings: global helpers, validation messages, and per-form-type success messages (buyer, seller, landlord, newsletter, property match).
 */
import { messageRef } from '../messageRef';

export const formCopy = {
  global: {
    intro: messageRef('forms.global.intro'),
    privacy: messageRef('forms.global.privacy'),
    emailHelper: messageRef('forms.global.emailHelper'),
    phoneHelper: messageRef('forms.global.phoneHelper'),
  },
  validation: {
    nameRequired: messageRef('forms.validation.nameRequired'),
    emailRequired: messageRef('forms.validation.emailRequired'),
    phoneRequired: messageRef('forms.validation.phoneRequired'),
    addressRequired: messageRef('forms.validation.addressRequired'),
    requiredFields: messageRef('forms.validation.requiredFields'),
  },
  buyer: {
    successMessage: messageRef('forms.buyer.successMessage'),
  },
  seller: {
    successMessage: messageRef('forms.seller.successMessage'),
  },
  landlord: {
    successMessage: messageRef('forms.landlord.successMessage'),
  },
  newsletter: {
    subtitle: messageRef('forms.newsletter.subtitle'),
    reassurance: messageRef('forms.newsletter.reassurance'),
    successMessage: messageRef('forms.newsletter.successMessage'),
  },
  propertyMatch: {
    successMessage: messageRef('forms.dealFinder.successMessage'),
    missingQualification: messageRef('forms.dealFinder.missingQualification'),
  },
} as const;
